import React from 'react';
import { TableCellProps } from '../../../types/search';

const PortalCellUrl: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  if (!row.url) return null;

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--url portal-cell--no-margin`}>
      <a className="portal-cell__link" href={row.url as string} aria-label="Go to service page">
        <svg className="portal-cell__link-icon icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#arrow-right-medium-portal"></use>
        </svg>
      </a>
    </div>
  );
};

export default PortalCellUrl;
